var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRadioGroup } from '../../context';
import { RadioTestIdFactory } from '../../interactions';
import { RADIO_GROUP_ITEMS_PER_COLUMN } from '../../Radio.constants';
import { RadioInput } from '../RadioInput';
import styles from './RadioGroup.module.css';
export const RadioGroup = ({ 'aria-describedby': ariaDescribedBy, 'aria-errormessage': ariaErrorMessage, 'aria-invalid': ariaInvalid, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'data-testid': testid, items, label, name, onBlur, onChange, onFocus, radioGroupItemsPerColumn = RADIO_GROUP_ITEMS_PER_COLUMN, ref, required, selectedValue: selectedValueFromProps, }) => {
    _react_refresh_temp_2();
    const { radioGroupData: { value: selectedValueFromContext }, setRadioGroupValue: setRadioGroupContextValue, } = useRadioGroup();
    const selectedValue = selectedValueFromProps ?? selectedValueFromContext;
    const rows = items.reduce((acc, it) => {
        const lastColumn = acc.at(-1);
        const newItem = {
            ...it,
            'data-testid': `${testid}-radio-item`,
        };
        if (Array.isArray(lastColumn) &&
            lastColumn.length < radioGroupItemsPerColumn) {
            const accCopy = [...acc];
            accCopy.pop();
            return [...accCopy, [...lastColumn, newItem]];
        }
        return [...acc, [newItem]];
    }, []);
    return (_jsxs("fieldset", { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: styles.Container, "data-testid": RadioTestIdFactory.getRadioGroupContainerTestId(testid), children: [label ? _jsx("legend", { className: styles.Label, children: label }) : null, _jsx("div", { className: styles.RowsWrapper, children: rows.map((row, rowIndex) => {
                    const rowKey = row.map(({ value }) => value).join('-');
                    return (_jsx("div", { className: styles.Row, children: row.map((item, itemIndex) => (_jsx(RadioInput, { "data-testid": RadioTestIdFactory.internalGenerateRadioItemTestId(testid, item.value), description: item.description, disabled: item.disabled, id: `${name}-${item.value}`, kind: item.kind, label: item.label, name: name, onBlur: onBlur, onChange: (value) => {
                                setRadioGroupContextValue(value);
                                if (onChange) {
                                    onChange(value);
                                }
                            }, onFocus: onFocus, ref: !rowIndex && !itemIndex
                                ? ref
                                : undefined, required: required, selectedValue: selectedValue, value: item.value, ...(ariaDescribedBy && {
                                'aria-describedby': ariaDescribedBy,
                            }), ...(ariaErrorMessage && {
                                'aria-errormessage': ariaErrorMessage,
                            }), ...(ariaInvalid && {
                                'aria-invalid': true,
                            }) }, item.value))) }, rowKey));
                }) })] }));
};
_react_refresh_temp_1 = RadioGroup;
$RefreshReg$(_react_refresh_temp_1, "RadioGroup");
_react_refresh_temp_2(RadioGroup, "Nk7CIGuYaQ1DmDm2cbPMT3NBtzY=", false, () => [useRadioGroup]);
